import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@tremor/react';
import { TimeOffTab } from './components/TimeOffTab';
import { useSearchParams } from 'react-router-dom';
import { TimeAwayRoute } from '../TimeAway';

export default function TimeOffRoute() {
  // `?tab=mine` opens "My Time Away" (emails link there).
  const [searchParams] = useSearchParams();
  const defaultIndex = searchParams.get('tab') === 'mine' ? 1 : 0;

  return (
    <>
      <div className="flex flex-col gap-3 border-b-2 border-[#E4E4E7] pb-4 sm:flex-row sm:items-center sm:justify-between">
        <h1 className="text-2xl font-bold text-tremor-content-strong sm:text-3xl">
          Time Off Management
        </h1>

        {/* <button
          className="flex items-center gap-2 rounded-lg bg-gradient-to-r 
          from-[#F77B23] to-[#F69620] px-5 py-2 font-normal text-white"
        >
          <AiGenerateIcon />
          Redstone AI
        </button> */}
      </div>
      <div className="my-4">
        <TabGroup defaultIndex={defaultIndex}>
          <TabList variant="solid" color="rose" className="sticky top-0 z-10 bg-white py-2">
            <Tab className="px-3 py-2 text-sm sm:px-4">Requests</Tab>
            <Tab className="px-3 py-2 text-sm sm:px-4">My Time Away</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <TimeOffTab />
            </TabPanel>
            <TabPanel>
              <TimeAwayRoute />
            </TabPanel>
          </TabPanels>
        </TabGroup>
      </div>
    </>
  );
}
